<template>
<v-app light>
  <v-navigation-drawer temporary v-model="drawer" enable-resize-watcher>
    <v-list class="pa-0">
      <v-list-tile avatar tag="div">
        <v-list-tile-avatar>
          <img :src="require('./assets/DOB-Energy-Logo-RGB_Horizontal-Colour-geoLOGIC-Tag-left.png')" />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="app-title">Assets for Sale</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action class="menu-chevron">
          <v-btn icon @click.native.stop="drawer = !drawer">
            <v-icon>chevron_left</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider light />
    <v-list>
      <v-list-tile tag="div" class="app-menu-item">
        <v-list-tile-action>
          <v-switch color="primary" light v-model="assetManager" />
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Assets</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list dense>
        <v-list-tile avatar style="padding-left: 40px" tag="div">
          <v-list-tile-action>
            <v-switch color="primary" light v-model="royaltyLayer" :disabled="!assetManager" />
          </v-list-tile-action>
          <v-list-tile-title>
            Royalty
          </v-list-tile-title>
          <v-list-tile-avatar>
            <v-icon x-large style="color: #0085b1;">
              stop
            </v-icon>
          </v-list-tile-avatar>
        </v-list-tile>

        <v-list-tile avatar style="padding-left: 40px" tag="div">
          <v-list-tile-action>
            <v-switch color="primary" light v-model="productionLayer" :disabled="!assetManager" />
          </v-list-tile-action>
          <v-list-tile-title>
            Production
          </v-list-tile-title>
          <v-list-tile-avatar>
            <v-icon x-large style="color: #ef5534;">
              stop
            </v-icon>
          </v-list-tile-avatar>
        </v-list-tile>

        <v-list-tile avatar style="padding-left: 40px" tag="div">
          <v-list-tile-action>
            <v-switch color="primary" light v-model="landLayer" :disabled="!assetManager" />
          </v-list-tile-action>
          <v-list-tile-title>
            Land
          </v-list-tile-title>
          <v-list-tile-avatar>
            <v-icon x-large style="color: #85a800;">
              stop
            </v-icon>
          </v-list-tile-avatar>
        </v-list-tile>
      </v-list>

      <v-list-tile tag="div">
        <v-list-tile-action>
          <v-switch color="primary" light v-model="pipelineLayer" />
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Pipelines</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list dense>
        <v-list-tile avatar style="padding-left: 40px" tag="div">
          <v-list-tile-title>
            Oil
          </v-list-tile-title>
          <v-list-tile-avatar>
            <v-icon large style="color: #e41a1c;">
              drag_handle
            </v-icon>
          </v-list-tile-avatar>
        </v-list-tile>

        <v-list-tile avatar style="padding-left: 40px" tag="div">
          <v-list-tile-title>
            Gas
          </v-list-tile-title>
          <v-list-tile-avatar>
            <v-icon large style="color: #4DAF4A;">
              drag_handle
            </v-icon>
          </v-list-tile-avatar>
        </v-list-tile>

        <v-list-tile avatar style="padding-left: 40px" tag="div">
          <v-list-tile-title>
            Multiuse
          </v-list-tile-title>
          <v-list-tile-avatar>
            <v-icon large style="color: #377EB8;">
              drag_handle
            </v-icon>
          </v-list-tile-avatar>
        </v-list-tile>

        <v-list-tile avatar style="padding-left: 40px" tag="div">
          <v-list-tile-title>
            Not Indentified
          </v-list-tile-title>
          <v-list-tile-avatar>
            <v-icon large style="color: #984EA3;">
              drag_handle
            </v-icon>
          </v-list-tile-avatar>
        </v-list-tile>
      </v-list>

      <v-list-tile tag="div">
        <v-list-tile-action>
          <v-switch color="primary" light v-model="gridLayer" />
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Township Grid</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider light />
    <v-list>
      <v-list-tile @click.native.stop="drawer = false, tour()">
        <v-list-tile-content>
          <v-list-tile-title>Take a Tour</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile href="mailto:customerservice@dobenergy.com" target="_blank">
        <v-list-tile-content>
          <v-list-tile-title>Get Help</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>

  <v-toolbar class="app-toolbar white elevation-1" floating dense>
    <v-toolbar-side-icon class="app-menu-icon" @click.native.stop="drawer = !drawer" light></v-toolbar-side-icon>
    <v-text-field class="app-search-box" prepend-icon="search" hide-details single-line placeholder="Search for Assets" @input="onInput" @keyup.esc="isOpen = false" v-model="keyword"></v-text-field>

    <v-dialog class="app-date-filter" v-model="dateDialog" lazy persistent>

      <v-btn icon slot="activator">
        <v-icon class="blue--text">access_time</v-icon>
      </v-btn>

      <v-card>
        <v-card-title>
          <div class="headline">Filter by posting date</div>
        </v-card-title>
        <v-card-actions style="padding: 0 16px;">
          <v-btn class="blue-grey lighten-3 elevation-0 white--text" small @click.native="dateDialog = false, filterByLastQuarter()">Last QTR</v-btn>
          <v-btn class="blue-grey lighten-3 elevation-0 white--text" small @click.native="dateDialog = false, filterByThisQuarter()">This QTR</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-flex xs12 sm6>
            <v-menu lazy :close-on-content-click="false" v-model="startDateMenu" transition="scale-transition" offset-y full-width :nudge-left="40" max-width="290px">
              <v-text-field slot="activator" label="From" v-model="startDate" prepend-icon="event" readonly></v-text-field>
              <v-date-picker v-model="startDate" no-title scrollable autosave />
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6>
            <v-menu lazy :close-on-content-click="false" v-model="endDateMenu" transition="scale-transition" offset-y full-width :nudge-left="40" max-width="290px">
              <v-text-field slot="activator" label="To" v-model="endDate" prepend-icon="event" readonly></v-text-field>
              <v-date-picker v-model="endDate" no-title scrollable autosave />
            </v-menu>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="dateDialog = false">Cancel</v-btn>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="dateDialog = false, filterByDate()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog class="app-table-view" v-model="listDialog" lazy persistent fullscreen transition="dialog-bottom-transition">

      <v-btn icon slot="activator">
        <v-icon class="blue--text">view_list</v-icon>
      </v-btn>

      <v-card>
        <v-toolbar dark class="primary">
          <v-btn icon @click.native="listDialog = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>List of Assets</v-toolbar-title>
        </v-toolbar>

        <v-card class="elevation-0">
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field append-icon="search" label="Search" single-line hide-details v-model="listSearch"></v-text-field>
          </v-card-title>
          <v-data-table :headers="listDataTableHeaders" :items="assetData" :search="listSearch">
            <template slot="items" scope="props">
                <td class="text-xs-left" style="width: 150px">{{ props.item.area }}</td>
                <td class="text-xs-left" style="width: 150px">{{ props.item.asset_type }}</td>
                <td class="text-xs-left" style="width: 200px">{{ props.item.company }}</td>
                <td class="text-xs-left" style="width: 150px">{{ props.item.agent }}</td>
                <td class="text-xs-left" style="width: 200px">{{ props.item.bid_date }}</td>
                <td class="text-xs-left" v-html="props.item.description"></td>
              </template>
            <template slot="pageText" scope="{ pageStart, pageStop }">
                From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </v-card>

      </v-card>
    </v-dialog>
  </v-toolbar>

  <div class="app-search-tags">

    <v-chip close v-model="tagCompany" class="primary white--text elevation-1 app-search-tag">
      <v-icon left>business</v-icon>
      {{ selectedCompany }}
    </v-chip>

    <v-chip close v-model="tagArea" class="primary white--text elevation-1 app-search-tag">
      <v-icon left>select_all</v-icon>
      {{ selectedArea }}
    </v-chip>

    <v-chip close v-model="tagAdvisor" class="primary white--text elevation-1 app-search-tag">
      <v-icon left>person</v-icon>
      {{ selectedAdvisor }}
    </v-chip>

    <v-chip close v-model="tagDate" class="primary white--text elevation-1 app-search-tag">
      <v-icon left>access_time</v-icon>
      {{ selectedDate }}
    </v-chip>

  </div>

  <v-list v-show="isOpen" class="autocomplete-list elevation-1">
    <template v-for="(item, index) in filteredItems">
      <v-list-tile class="autocomplete-list-item" v-if="hasResults === true" :key="index" @click.native="select(index)">
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-text="item.value"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider v-if="index < searchResult.length - 1"></v-divider>
    </template>
  </v-list>
  <main>
    <v-container fluid>
      <router-view name="Map"></router-view>
    </v-container>
  </main>
  <v-snackbar :timeout="snackbarTimeout" :top="snackbarY === 'top'" :bottom="snackbarY === 'bottom'" :right="snackbarX === 'right'" :left="snackbarX === 'left'" :multi-line="snackbarMode === 'multi-line'" :vertical="snackbarMode === 'vertical'" :success="snackbarContext === 'success'"
      :error="snackbarContext === 'error'" v-model="snackbar">
    {{ snackbarText }}
    <v-btn flat class="white--text" @click.native="closeSnackbar">Close</v-btn>
  </v-snackbar>

  <input type="hidden" :value="assetsLayer" />
  <input type="hidden" :value="assetData" />
  <input type="hidden" :value="snackbar" />
  <input type="hidden" :value="snackbarContext" />
  <input type="hidden" :value="snackbarTimeout" />
  <input type="hidden" :value="snackbarText" />
  <input type="hidden" :value="townshipHighlightLayer" />

  </div>
</v-app>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import hopscotch from 'hopscotch'
import {
  mapActions
} from 'vuex'

import {
  config
} from './config'

export default {
  data() {
    return {
      searchFilters: {
        company: null,
        area: null,
        agent: null,
        dls: null,
        date: null
      },

      layerFilters: [`asset_type='Royalty'`, `asset_type='Land'`, `asset_type='Production'`],

      drawer: false,

      dateDialog: false,
      startDateMenu: false,
      endDateMenu: false,
      startDate: null,
      endDate: null,

      listDialog: false,
      listSearch: '',
      listPagination: {},
      listDataTableHeaders: [{
          text: 'Area',
          value: 'area',
          align: 'left'
        },
        {
          text: 'Asset Type',
          value: 'asset_type',
          align: 'left'
        },
        {
          text: 'Company',
          value: 'company',
          align: 'left'
        },
        {
          text: 'Advisor',
          value: 'agent',
          align: 'left'
        },
        {
          text: 'Bid Date',
          value: 'bid_date',
          align: 'left'
        },
        {
          text: 'Description',
          value: 'description',
          align: 'left',
          sortable: false,
        }
      ],

      snackbarY: 'bottom',
      snackbarX: 'center',
      snackbarMode: 'multi-line',

      assetManager: true,
      royaltyLayer: true,
      productionLayer: true,
      landLayer: true,
      pipelineLayer: true,
      facilitiesLayer: null,
      gridLayer: true,

      serverUrl: config.serverUrl,
      isOpen: false,
      hasResults: false,
      keyword: null,
      searchResult: [],
      selectedItem: null,
      geom: '',

      tagCompany: false,
      selectedCompany: null,
      tagArea: false,
      selectedArea: null,
      tagAdvisor: false,
      selectedAdvisor: null,
      tagDate: false,
      selectedDate: null,

      inTour: false
    }
  },
  methods: {
    ...mapActions([
      'loadAssetsLayer',
      'updateTownshipHighlightLayer'
    ]),
    onInput(value) {
      this.isOpen = !!value

      var wfsParams = {
        service: 'WFS',
        version: '2.0.0',
        request: 'GetFeature',
        typeName: 'jwn:search_autocomplete',
        outputFormat: 'application/json',
        srsname: 'EPSG:4326',
        viewparams: 'query:' + this.keyword
      }

      if (this.keyword !== null && this.keyword !== '') {

        var app = this
        axios.get(app.serverUrl, {
            params: wfsParams
          })
          .then(function(response) {
            const data = response.data
            app.searchResult = []
            for (var i = 0; i < data.features.length; i++) {
              var icon = ""
              switch (data.features[i].properties.column) {
                case "company":
                  icon = "business"
                  break;
                case "dls":
                  icon = "place"
                  break
                case "area":
                  icon = "select_all"
                  break
                case "agent":
                  icon = "person"
                  break
              }

              app.searchResult.push({
                value: data.features[i].properties.search_term,
                table: data.features[i].properties.table,
                column: data.features[i].properties.column,
                geom: data.features[i].geometry,
                icon: icon
              })
            }

          })
          .catch(function(error) {
            console.log(error)
          })
      }
    },
    select(index) {
      this.searchFilters["dls"] = null

      this.selectedItem = this.filteredItems[index]
      this.keyword = this.selectedItem.value
      this.geom = this.selectedItem.geom
      var table = this.selectedItem.table
      var column = this.selectedItem.column
      var filter = column + "='" + this.keyword + "'"
      this.searchFilters[column] = filter

      if (table === "dlsgrids") {
        this.$store.commit("updateDlsLayer", this.geom)
      } else {
        this.filterAssetLayer()
      }

      this.isOpen = false
      this.keyword = null

      switch (column) {
        case "company":
          this.tagCompany = true
          this.selectedCompany = this.selectedItem.value
          break
        case "area":
          this.tagArea = true
          this.selectedArea = this.selectedItem.value
          break
        case "agent":
          this.tagAdvisor = true
          this.selectedAdvisor = this.selectedItem.value
          break
      }
    },
    removeTag(tag) {
      this.searchFilters[tag] = null
      if (tag === 'date') {
        this.startDate = null
        this.endDate = null
      }
      this.filterAssetLayer()
      this.selectedItem = null
    },
    filterByDate() {
      this.searchFilters["dls"] = null

      this.$store.state.map.removeLayer(this.assetsLayer)

      let filter = `bid_date > '${this.startDate}' AND bid_date < '${this.endDate}'`
      this.searchFilters["date"] = filter

      this.tagDate = true
      this.selectedDate = `${this.startDate} - ${this.endDate}`

      this.filterAssetLayer()
    },
    closeSnackbar() {
      this.$store.state.snackbar = false
    },
    filterAssetLayer() {
      let _filters = []
      _.forEach(this.searchFilters, (value, key) => {
        value !== null && _filters.push(value)
      })

      let filters = _.join(this.layerFilters, ' OR ')
      if (_filters.length > 0) {
        filters = _.join(_filters, ' AND ') + ' AND (' + filters + ')'
      }

      this.$store.state.map.removeLayer(this.assetsLayer)

      this.townshipHighlightLayer !== null && this.$store.state.map.removeLayer(this.townshipHighlightLayer) && this.updateTownshipHighlightLayer(null)

      if (this.layerFilters.length > 0) {
        if (filters !== '') {
          this.loadAssetsLayer(filters)
        } else {
          this.loadAssetsLayer(null)
        }
      }
    },
    filterByThisQuarter() {
      let currentDate = new Date()
      let currentYear = currentDate.getFullYear()
      let currentMonth = currentDate.getMonth() < 10 ? `0${currentDate.getMonth()}` : currentDate.getMonth()
      let currentDay = currentDate.getDay() < 10 ? `0${currentDate.getDay()}` : currentDate.getDay()
      this.endDate = `${currentYear}-${currentMonth}-${currentDay}`

      if (currentMonth >= 1 & currentMonth <= 3) {
        this.startDate = `${currentYear}-01-01`
      } else if (currentMonth >= 4 & currentMonth <= 6) {
        this.startDate = `${currentYear}-03-01`
      } else if (currentMonth >= 7 & currentMonth <= 9) {
        this.startDate = `${currentYear}-06-01`
      } else if (currentMonth >= 10 & currentMonth <= 12) {
        this.startDate = `${currentYear}-09-01`
      }
      this.filterByDate()
    },
    filterByLastQuarter() {
      let currentDate = new Date()
      let currentYear = currentDate.getFullYear()
      let currentMonth = currentDate.getMonth() < 10 ? `0${currentDate.getMonth()}` : currentDate.getMonth()
      let currentDay = currentDate.getDay() < 10 ? `0${currentDate.getDay()}` : currentDate.getDay()

      if (currentMonth >= 1 & currentMonth <= 3) {
        this.startDate = `${currentYear - 1}-10-01`
        this.endDate = `${currentYear - 1}-12-31`
      } else if (currentMonth >= 4 & currentMonth <= 6) {
        this.startDate = `${currentYear}-01-01`
        this.endDate = `${currentYear}-03-31`
      } else if (currentMonth >= 7 & currentMonth <= 9) {
        this.startDate = `${currentYear}-04-01`
        this.endDate = `${currentYear}-06-30`
      } else if (currentMonth >= 10 & currentMonth <= 12) {
        this.startDate = `${currentYear}-07-01`
        this.endDate = `${currentYear}-09-30`
      }
      this.filterByDate()
    },
    tour() {
      let tour = {
        id: "assets-for-sale-tour",
        steps: [{
            title: "Menu",
            content: "Select the menu to turn layers on and off, take a tour, and get help.",
            target: document.querySelector(".app-menu-icon"),
            placement: "bottom",
            showCTAButton: true,
            ctaLabel: 'Open Menu',
            onCTA: () => {
              this.drawer = true
              setTimeout(() => {
                hopscotch.nextStep()
              }, 250)
            },
            onNext: () => {
              if (!this.drawer) {
                hopscotch.showStep(2)
              }
            }
          },
          {
            title: "Menu Items",
            content: "Turn on/off layers.",
            target: document.querySelector(".app-menu-item"),
            placement: "right",
            onNext: () => {
              this.drawer = false
            },
            onPrev: () => {
              this.drawer = false
            }
          },
          {
            title: "Search Box",
            content: "Assets can be keyword searched using the search bar.",
            target: document.querySelector(".app-search-box"),
            placement: "bottom",
            onPrev: () => {
              hopscotch.showStep(0)
            },
            showCTAButton: true,
            ctaLabel: 'Perform a Search',
            onCTA: () => {
              this.keyword = 'd'
              this.onInput(this.keyword)
              setTimeout(() => {
                hopscotch.nextStep()
              }, 350)
            },
            onNext: () => {
              if (this.keyword === null || this.keyword === '') {
                hopscotch.showStep(5)
              }
            }
          },
          {
            title: "Search Results",
            content: `Select any of the items in the search results.<br /><i class="material-icons">business</i> Comany | <i class="material-icons">select_all</i> Area | <i class="material-icons">person</i> Advisor`,
            target: document.querySelector(".autocomplete-list"),
            placement: "right",
            onPrev: () => {
              this.keyword = null
              this.searchResult = []
              this.isOpen = false
            },
            onNext: () => {
              this.keyword = null
              this.searchResult = []
              this.isOpen = false
              hopscotch.showStep(5)
            },
          },
          {
            title: "Search Tags & Pins",
            content: `This is the filter you just applied! Filters can be removed by selecting the <i class="material-icons">close</i> next to the filtered term.<br />You can now click on a map pin to drill down into the data.`,
            target: document.querySelector(".app-search-tags"),
            placement: "bottom",
            onPrev: () => {
              this.tagCompany = false
              this.tagAdvisor = false
              this.tagArea = false
              this.tagDate = false
              hopscotch.showStep(2)
            },
          },
          {
            title: "Temporal Filter",
            content: "Assets can also be filtered by time.",
            target: document.querySelector(".app-date-filter"),
            placement: "bottom",
            onPrev: () => {
              hopscotch.showStep(2)
            },
          },
          {
            title: "Table View",
            content: "The data can be viewed in a table.",
            target: document.querySelector(".app-table-view"),
            placement: "bottom"
          }
        ],
        showPrevButton: true,
        onStart: () => {
          this.inTour = true
        },
        onClose: () => {
          this.inTour = false
        },
        onEnd: () => {
          this.inTour = false
        }
      }

      hopscotch.startTour(tour, 0)

      localStorage.setItem('first_time_visitor', true)
    }
  },
  computed: {
    filteredItems() {
      if (this.searchResult.length > 0) {
        this.hasResults = true
      } else {
        this.hasResults = false
      }
      return this.searchResult
    },
    assetData() {
      return this.$store.state.assetData
    },
    assetsLayer() {
      return this.$store.state.assetsLayer
    },
    snackbar() {
      return this.$store.state.snackbar
    },
    snackbarContext() {
      return this.$store.state.snackbarContext
    },
    snackbarTimeout() {
      return this.$store.state.snackbarTimeout
    },
    snackbarText() {
      return this.$store.state.snackbarText
    },
    townshipHighlightLayer() {
      return this.$store.state.townshipHighlightLayer
    }
  },
  watch: {
    selectedItem() {
      if (this.selectedItem !== null && this.inTour === true) {
        setTimeout(() => {
          hopscotch.showStep(4)
        }, 350)
      }
    },
    assetManager() {
      this.$store.commit('updateAssetManager', this.assetManager)
    },
    royaltyLayer() {
      if (this.royaltyLayer) {
        this.layerFilters.push(`asset_type='Royalty'`)
      } else {
        this.layerFilters.splice(this.layerFilters.indexOf(`asset_type='Royalty'`), 1)
      }
      this.filterAssetLayer()
    },
    landLayer() {
      if (this.landLayer) {
        this.layerFilters.push(`asset_type='Land'`)
      } else {
        this.layerFilters.splice(this.layerFilters.indexOf(`asset_type='Land'`), 1)
      }
      this.filterAssetLayer()
    },
    productionLayer() {
      if (this.productionLayer) {
        this.layerFilters.push(`asset_type='Production'`)
      } else {
        this.layerFilters.splice(this.layerFilters.indexOf(`asset_type='Production'`), 1)
      }
      this.filterAssetLayer()
    },
    pipelineLayer() {
      this.$store.commit('updatePipelineLayer', this.pipelineLayer)
    },
    gridLayer() {
      this.$store.commit('updateGridLayer', this.gridLayer)
    },
    tagCompany() {
      if (!this.tagCompany) {
        this.removeTag('company')
      }
    },
    tagArea() {
      if (!this.tagArea) {
        this.removeTag('area')
      }
    },
    tagAdvisor() {
      if (!this.tagAdvisor) {
        this.removeTag('agent')
      }
    },
    tagDate() {
      if (!this.tagDate) {
        this.removeTag('date')
      }
    }
  },

  mounted() {
    this.$store.commit('updateAssetManager', this.assetManager)
    this.$store.commit('updatePipelineLayer', this.pipelineLayer)
    this.$store.commit('updateGridLayer', this.gridLayer)
    if (!localStorage.getItem('first_time_visitor')) {
      this.tour()
    }
  },


}
</script>

<style lang="stylus">
  @import './stylus/main'
</style>
<style land="css">
@import '../node_modules/hopscotch/dist/css/hopscotch.min.css';

.app-toolbar .input-group__details {
  display: none;
}

.list__tile__title {
  font-weight: 100;
}

.app-toolbar {
  z-index: 1;
  max-width: 100%;
}

.autocomplete-list {
  /*border: 1px solid #dbdbdb;*/
  overflow: hidden;
  z-index: 1;
  position: absolute;
  margin: -16px 16px;
  background-color: #fff;
  width: 365px;
}

.app-search-box::after {
  content: "";
  position: absolute;
  right: 0;
  border-left: 1px solid #ddd;
  height: 28px;
}

.app-search-tags {
  position: absolute;
  z-index: 1;
  margin: -16px 16px;
}

.app-search-tag {
  margin: 8px 8px 8px 0;
}

#app .dialog__container {
  margin-right: 0;
}

.app-popup table {
  border-collapse: collapse;
  width: 100%;
}

.app-popup th,
.app-popup td {
  text-align: left;
  padding: 8px;
}

.app-popup tr:nth-child(even) {
  background-color: #f2f2f2
}

.material-icons {
  font-size: 20px;
  vertical-align: bottom;
}

.hopscotch-bubble {
  z-index: 4 !important;
}

@media screen and (max-width: 600px) {
  #app .toolbar__content {
    min-width: 100%;
  }

  .autocomplete-list {
    width: 372px !important;
  }
}

@media screen and (max-width: 375px) {

  #app div.input-group__input {
    width: 120px !important;
  }

  .autocomplete-list {
    width: 311px !important;
  }
}

@media screen and (max-width: 320px) {
  #app .toolbar__content {
    min-width: 300px;
  }
  #app div.input-group__input {
    width: 100px !important;
  }

  .autocomplete-list {
    width: 311px !important;
  }
}

#app div.menu__content {
  right: 30px !important;
  /*left: auto !important;*/
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), 0 1px 1px rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12) !important;
}

#app .list__tile__sub-title {
  font-size: 12px !important;
}

#app div.input-group__input {
  min-height: auto !important;
}

#app .toolbar__content {
  /*min-width: 311px;*/
  min-width: 311px;
}

.avatar img {
  border-radius: 0 !important;
  height: 25px;
  width: auto;
  margin-top: 4px;
}

.app-title {
  font-weight: 700;
  text-align: right;
  font-size: 16px;
}

.menu-chevron {
  margin-left: 10px;
  min-width: 20px;
  max-width: 20px;
}
</style>



// WEBPACK FOOTER //
// App.vue?a679f300